import { Component, Input } from '@angular/core';

@Component({
  selector: 'rates',
  templateUrl: 'rates.html'
})
export class RatesComponent {

  @Input() taxRate: any;
  @Input() taxShield: any;
  @Input() discountRate: any;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/rates/rates.ts